(function () {
  'use strict';

  var COLOR_MAP = {
    'Shiny Rose':    '#F1C9C9',
    'Soft Black':    '#000000',
    'Soft Espresso': '#514242',
    'Sky Blue':      '#B9D9EA',
    'Lavender':      '#D6C7E8',
    'Rosa':          '#F1C9C9',
    'Svart':         '#000000',
    'Vit':           '#FFFFFF',
  };

  var allVariants = [], swatchData = [], selectedIds = [], activeQty = 1, interceptAttached = false, suppressTopSync = false;
  var SEL_BUNDLE_WRAP  = '.bundle-options';
  var SEL_BUNDLE_INPUT = '.bundle-option__input';
  var SEL_VISUAL_BTN   = '.visual-option-btn';
  var SEL_PRODUCT_FORM = 'form[id*="product-form"]';
  var SEL_BC_WRAP      = '.bc-wrap';

  function boot() {
    if (!document.querySelector(SEL_BUNDLE_WRAP)) return;
    loadVariants();
    buildSwatchData();
    if (!swatchData.length) return;
    window.BundleMultiColor = { swatches: swatchData };
    document.addEventListener('change', onBundleChange);
    document.addEventListener('click', onTopSwatchClick);
    attachCartIntercept();
    injectCSS();
    var checked = document.querySelector(SEL_BUNDLE_INPUT + ':checked');
    if (checked) {
      activeQty = parseInt(checked.dataset.quantity, 10) || 1;
      if (activeQty > 1) renderSelectors(activeQty, checked);
    }
  }

  function loadVariants() {
    var el = document.querySelector('script.variant-data');
    if (el) { try { allVariants = JSON.parse(el.textContent); } catch (_) {} }
  }

  function buildSwatchData() {
    var seen = {};
    document.querySelectorAll(SEL_VISUAL_BTN).forEach(function (btn) {
      var value = btn.dataset.value;
      if (!value || seen[value]) return;
      seen[value] = true;
      var available = btn.dataset.available !== 'false';
      var variant = allVariants.find(function (v) { return v.option1 === value || v.title === value; });
      swatchData.push({
        value: value,
        color: COLOR_MAP[value] || '#cccccc',
        available: variant ? variant.available : available,
        variantId: variant ? variant.id : null,
      });
    });
  }

  function currentTopColor() {
    var active = document.querySelector(SEL_VISUAL_BTN + '.active');
    return active ? active.dataset.value : (swatchData[0] ? swatchData[0].value : '');
  }

  function variantByColor(colorName) {
    var match = swatchData.find(function (c) { return c.value === colorName; });
    return match ? match.variantId : null;
  }

  function onBundleChange(e) {
    if (!e.target.matches(SEL_BUNDLE_INPUT)) return;
    activeQty = parseInt(e.target.dataset.quantity, 10) || 1;
    destroySelectors();
    if (activeQty > 1) renderSelectors(activeQty, e.target);
  }

  function onTopSwatchClick(e) {
    if (suppressTopSync) return;
    var btn = e.target.closest(SEL_VISUAL_BTN);
    if (!btn || btn.closest(SEL_BC_WRAP)) return;
    if (activeQty <= 1) return;
    setTimeout(syncSlotsToTopColor, 0);
  }

  function syncSlotsToTopColor() {
    var color = currentTopColor();
    selectedIds = selectedIds.map(function () { return variantByColor(color); });
    document.querySelectorAll('.bc-row').forEach(function (row) {
      var nameEl = row.querySelector('.bc-label__color');
      if (nameEl) nameEl.textContent = color;
      row.querySelectorAll('.bc-swatch').forEach(function (s) {
        s.classList.toggle('bc-swatch--active', s.dataset.value === color);
      });
    });
  }

  function renderSelectors(qty, radioInput) {
    destroySelectors();
    var color = currentTopColor();
    var vid = variantByColor(color);
    selectedIds = [];
    for (var i = 0; i < qty; i++) selectedIds.push(vid);
    var wrap = document.createElement('div');
    wrap.className = 'bc-wrap';
    for (var j = 0; j < qty; j++) { wrap.appendChild(buildRow(j, color)); }
    var optionDiv = radioInput.closest('.bundle-option');
    var target = optionDiv && optionDiv.querySelector('.bundle-option__content');
    if (target) { target.appendChild(wrap); }
    else { document.querySelector(SEL_BUNDLE_WRAP).insertAdjacentElement('afterend', wrap); }
  }

  function destroySelectors() {
    var el = document.querySelector(SEL_BC_WRAP);
    if (el) el.remove();
    selectedIds = [];
  }

  function bundleTranslation(key, fallback) {
    return (window.theme && window.theme.translations && window.theme.translations[key]) || fallback;
  }

  function buildRow(slotIdx, defaultColor) {
    var row = document.createElement('div');
    row.className = 'bc-row';
    row.dataset.slot = slotIdx;
    var label = document.createElement('div');
    label.className = 'bc-label';
    var itemLabel = bundleTranslation('bundle_item_label', 'Item');
    label.innerHTML =
      '<span class="bc-label__brush">' + itemLabel + ' ' + (slotIdx + 1) + ':</span>' +
      ' <span class="bc-label__color">' + defaultColor + '</span>';

    // "Buy N-1, get 1 free" tiers (3-unit or 4-unit): the LAST slot is the
    // free one. Only shown on products actually gated for cart nesting
    // (window.bundleNestingEnabled, set from custom.bundle_price in
    // bundle-options.liquid) — this label must not appear on every product
    // that happens to have a quantity-tier bundle selector.
    if (window.bundleNestingEnabled && (activeQty === 3 || activeQty === 4) && slotIdx === activeQty - 1) {
      var gratisEl = document.createElement('span');
      gratisEl.className = 'bc-label__gratis';
      gratisEl.textContent = bundleTranslation('bundle_free_label', 'Free');
      label.appendChild(gratisEl);
    }

    var swatches = document.createElement('div');
    swatches.className = 'bc-swatches';
    swatchData.forEach(function (opt) {
      var isActive = opt.value === defaultColor;
      var isDisabled = !opt.available;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bc-swatch' + (isActive ? ' bc-swatch--active' : '') + (isDisabled ? ' bc-swatch--disabled' : '');
      btn.dataset.value = opt.value;
      btn.disabled = isDisabled;
      btn.title = opt.value;
      var circle = document.createElement('span');
      circle.className = 'bc-swatch__circle';
      circle.style.backgroundColor = opt.color;
      btn.appendChild(circle);
      if (isDisabled) {
        var slash = document.createElement('span');
        slash.className = 'bc-swatch__slash';
        slash.setAttribute('aria-hidden', 'true');
        btn.appendChild(slash);
      }
      btn.addEventListener('click', function () { onSlotClick(slotIdx, opt, btn); });
      swatches.appendChild(btn);
    });
    row.appendChild(label);
    row.appendChild(swatches);
    return row;
  }

  function onSlotClick(slotIdx, opt, clickedBtn) {
    if (!opt.available) return;
    selectedIds[slotIdx] = opt.variantId;
    var row = document.querySelector('.bc-row[data-slot="' + slotIdx + '"]');
    if (!row) return;
    row.querySelectorAll('.bc-swatch').forEach(function (s) { s.classList.remove('bc-swatch--active'); });
    clickedBtn.classList.add('bc-swatch--active');
    var nameEl = row.querySelector('.bc-label__color');
    if (nameEl) nameEl.textContent = opt.value;

    // Slot 1 (Borste 1) also drives the MAIN variant selector — it's what
    // determines the page's own product image/price/URL and, from there,
    // the cart's header image. Slots 2+ stay purely internal to the bundle.
    if (slotIdx === 0) syncTopToSlotZero(opt);
  }

  function syncTopToSlotZero(opt) {
    var topBtn = document.querySelector(SEL_VISUAL_BTN + '[data-value="' + CSS.escape(opt.value) + '"]');
    if (!topBtn || topBtn.closest(SEL_BC_WRAP) || topBtn.classList.contains('active')) return;
    // Reuse the real click handler in variant-picker-visual.liquid (updates
    // the hidden option input, price, media gallery, URL, variant:change
    // event) instead of duplicating that logic here. Suppress our own
    // onTopSwatchClick side effect for the duration so it doesn't force
    // slots 2/3 to match too.
    suppressTopSync = true;
    topBtn.click();
    suppressTopSync = false;
  }

  function attachCartIntercept() {
    if (interceptAttached) return;
    interceptAttached = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[name="add"], button[type="submit"].add-to-cart');
      if (!btn) return;

      var form = btn.closest(SEL_PRODUCT_FORM);
      if (!form) return;

      if (activeQty <= 1) return;

      var wrap = document.querySelector(SEL_BC_WRAP);
      if (!wrap || getComputedStyle(wrap).display === 'none') return;

      e.preventDefault();
      e.stopImmediatePropagation();

      doCartAdd(form);
    }, true); // capture phase — runs before Minimog's click handler
  }

  // Deduplicated, sorted list of variant ids — used to compare "the set of
  // colours chosen" between two bundles regardless of order or how many of
  // each colour.
  function colorSet(variantIds) {
    var seen = {};
    var out = [];
    variantIds.forEach(function (id) {
      if (!seen[id]) { seen[id] = true; out.push(id); }
    });
    return out.sort(function (a, b) { return a - b; });
  }

  function sameColorSet(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  // Finds an existing bundle (for this product) whose lines cover the exact
  // same set of colours as `chosenIds` — re-adding the same combination
  // should grow that bundle's quantities, not create a visually separate one.
  function findMatchingBundle(cart, productId, chosenIds) {
    var newSet = colorSet(chosenIds);
    var groups = {};
    cart.items.forEach(function (item) {
      var bundleId = item.properties && item.properties._bundle_id;
      if (!bundleId || item.product_id !== productId) return;
      (groups[bundleId] = groups[bundleId] || []).push(item);
    });
    for (var bundleId in groups) {
      if (sameColorSet(colorSet(groups[bundleId].map(function (i) { return i.variant_id; })), newSet)) {
        return groups[bundleId];
      }
    }
    return null;
  }

  function mergeIntoBundle(existingItems, chosenIds) {
    var addCounts = {};
    chosenIds.forEach(function (id) {
      addCounts[id] = (addCounts[id] || 0) + 1;
    });
    var updates = {};
    var touchedKeys = {};
    existingItems.forEach(function (item) {
      updates[item.key] = item.quantity + (addCounts[item.variant_id] || 0);
      touchedKeys[item.key] = true;
    });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates }),
    }).then(function (res) {
      if (!res.ok) return res.text().then(function (t) { throw new Error(t || ('HTTP ' + res.status)); });
      return res.json();
    }).then(function (cart) {
      // /cart/update.js resolves with the whole cart, not just the touched
      // lines — reshape to {items: [...]} like /cart/add.js so
      // triggerCartUpdate's `data.items[0]` is actually one of ours.
      return { items: cart.items.filter(function (item) { return touchedKeys[item.key]; }) };
    });
  }

  function addNewBundle(chosenIds, mainVariantId) {
    var bundleId = 'bmc_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);

    // Tag each line with the slot it was FIRST chosen at, so the cart can
    // render "Item 1, Item 2, Item 3" in selection order — cart.items order
    // isn't guaranteed to match. Two slots with the same colour get the SAME
    // slot number (their earliest shared index) so their properties stay
    // identical and they still merge into one cart line.
    var firstIndexOf = {};
    var unitQty = {};
    chosenIds.forEach(function (id, idx) {
      if (!(id in firstIndexOf)) firstIndexOf[id] = idx;
      unitQty[id] = (unitQty[id] || 0) + 1;
    });
    // How many units of THIS colour make up one set (e.g. 2 for a colour
    // picked in 2 of 3 slots) — the cart's +/- stepper needs this to scale
    // by the right amount per line instead of always doing +1/-1.
    // _bundle_main_variant_id records whichever variant was active on the
    // MAIN (top) variant selector at add time — the cart's header image
    // must always show that one, not whatever ends up in slot 1, since a
    // per-slot swatch can be overridden independently afterwards.
    var items = chosenIds.map(function (id) {
      return {
        id: id,
        quantity: 1,
        properties: {
          _bundle_id: bundleId,
          _bundle_slot: String(firstIndexOf[id]),
          _bundle_unit_qty: String(unitQty[id]),
          _bundle_main_variant_id: String(mainVariantId || id),
        },
      };
    });
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (res) {
      if (!res.ok) return res.text().then(function (t) { throw new Error(t); });
      return res.json();
    });
  }

  function doCartAdd(form) {
    var submitBtn = form.querySelector('[name="add"]') || form.querySelector('[type="submit"]');
    var origText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = '…'; }

    var fallbackId = (swatchData.find(function (c) { return c.available; }) || {}).variantId;
    var chosenIds = selectedIds.map(function (id) { return id || fallbackId; }).filter(Boolean);

    if (!chosenIds.length) {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
      return;
    }

    var productId = allVariants[0] && allVariants[0].product_id;
    // Cart header image follows whatever colour is picked in the FIRST
    // bc-swatches row (slot 1) specifically — not the top/main variant
    // selector, and not slots 2/3.
    var mainVariantId = chosenIds[0];

    // checkbox-cross-sell.js defers its own /cart/add.js call to us whenever
    // this multi-colour selector owns the click (see its ownedByOtherWidget)
    // — pick up whatever it left selected and add it as its own line item.
    var extraItems = (typeof window.getExtraCartItems === 'function') ? window.getExtraCartItems() : [];

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var existingGroup = productId ? findMatchingBundle(cart, productId, chosenIds) : null;
        return existingGroup ? mergeIntoBundle(existingGroup, chosenIds) : addNewBundle(chosenIds, mainVariantId);
      })
      .then(function (data) {
        if (!extraItems.length) return data;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: extraItems }),
        }).then(function (res) {
          if (!res.ok) return res.text().then(function (t) { throw new Error(t); });
          return res.json();
        }).then(function () { return data; });
      })
      .then(function (data) {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
        triggerCartUpdate(data);
        if (typeof window.resetExtraCartItems === 'function') window.resetExtraCartItems();
      })
      .catch(function (err) {
        console.error('[bundle-multi-color] Cart error:', err.message);
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
      });
  }

  function triggerCartUpdate(data) {
    if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
      var lineItem = (data && data.items && data.items[0]) ? data.items[0] : data;
      window.Shopify.onItemAdded(lineItem);
      return;
    }
    if (window.MinimogEvents && typeof window.MinimogEvents.emit === 'function') {
      window.MinimogEvents.emit('ON_ITEM_ADDED', data);
    }
  }

  function injectCSS() {
    if (document.getElementById('bc-multi-color-css')) return;
    var s = document.createElement('style');
    s.id = 'bc-multi-color-css';
    s.textContent =
      '.bc-wrap{display:flex;flex-direction:column;gap:12px;margin-top:14px;margin-left:-32px;}' +
      '.bc-row{display:flex;flex-direction:column;gap:8px;}' +
      '.bc-label{font-size:14px;font-weight:700;color:#2D3748;line-height:1.6;}' +
      '.bc-label__brush{font-weight:700;}' +
      '.bc-label__color{font-weight:700;}' +
      '.bc-label__gratis{display:inline-flex;background:#D62E55;color:#fff;padding:2px 8px;border-radius:12px;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.5px;margin-left:6px;vertical-align:middle;}' +
      '.bc-swatches{display:flex;flex-wrap:wrap;align-items:center;gap:12px;}' +
      '.bc-swatch{position:relative;display:flex;align-items:center;justify-content:center;padding:3px;border:1px solid transparent;border-radius:999px;cursor:pointer;background:transparent;transition:border-color .15s ease;flex-shrink:0;}' +
      '.bc-swatch--active{border-color:#000000;}' +
      '.bc-swatch--disabled{opacity:.5;cursor:not-allowed;}' +
      '.bc-swatch__circle{display:block;width:32px;height:32px;border-radius:9999px;}' +
      '.bc-swatch__slash{position:absolute;inset:3px;border-radius:9999px;pointer-events:none;overflow:hidden;}' +
      '.bc-swatch__slash::before{content:"";position:absolute;inset:0;background:linear-gradient(to bottom right,transparent calc(50% - .75px),#CCC9CA calc(50% - .75px),#CCC9CA calc(50% + .75px),transparent calc(50% + .75px));}';
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
}());
